<template>
    <div class="c-bgwrap">
        <div style="z-index: 2; position: relative; height: 100%; width: 100%">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
.c-bgwrap {
    position: relative;
    &::before {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        z-index: 0;
        position: absolute;
        top: 0px;
        left: 0px;
        border: 56px solid;
        box-sizing: border-box;
        border-image: url(./imgs/bg_wrap.png) 56 56;
    }
}
</style>
